import { render, staticRenderFns } from "./NuevaTransferencia.vue?vue&type=template&id=48efa402&"
import script from "./NuevaTransferencia.vue?vue&type=script&lang=js&"
export * from "./NuevaTransferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports